module.exports = __webpack_public_path__ + "81115bb46399124ea37c4a0d47cda17a.svg";